import type { MetaFunction } from "@remix-run/node";
import HeroSection from "../ui-apps/components/HeroSection";
import ScreenerSection from "../ui-apps/screener-app/ScreenerSection";
import mockFilterListItem from '../ui-apps/filterData/screener_filters.json';
import type { FilterItem } from "~/ui-apps/screener-app/ScreenerSection";
import { useOutletContext } from "@remix-run/react";

export const meta: MetaFunction = () => {
    return [
        { title: "MarketDataFyi: Built for long term stock market investors." },
        { name: "description", content: "Welcome to MarketDataFyi" },
    ];
};

export default function Index() {

    const { auth } = useOutletContext<{
        auth: { isAuthenticated: boolean, user: any, displayPricingModal: boolean, isBeta: boolean },
    }>();

    return (
        <>
            <main className="mt-28">
                <ScreenerSection filterList={mockFilterListItem as FilterItem[]} isHomePage={true} placeholder="Set your own criteria..." isAuthenticated={auth.isAuthenticated} user={auth.user} displayPricingModal={auth.displayPricingModal} isBeta={auth.isBeta} />
            </main>
        </>
    );
}